import "zod-openapi/extend";
import { z } from "zod";
import {
  BlockBaseSchema,
  BlockIdSchema,
  ComponentBlockStyleSchema,
} from "block-system/types/base";
import { blockType } from "./constants";

const AIGeneratedBlockConfigSchema = z.object({
  id: BlockIdSchema.optional(),
  title: z.string().optional(),
  tableIds: z.array(z.string()).optional(),
  content: z.object({
    type: z.literal("jsx"),
    value: z.string(),
    version: z.enum(["1.0.0"]),
  }),
  processedContent: z.object({
    type: z.literal("js"),
    value: z.string(),
    version: z.enum(["1.0.0"]),
  }),
  propsData: z.record(z.string()).optional(),
  style: ComponentBlockStyleSchema.default({
    alignment: "center",
    width: "wide",
  }).openapi({ effectType: "input" }),
});

export const AIGeneratedBlockSchema = BlockBaseSchema.extend({
  type: z.literal(blockType),
  config: AIGeneratedBlockConfigSchema,
}).openapi({ ref: "AIGeneratedBlock" });

export type AIGeneratedBlock = z.infer<typeof AIGeneratedBlockSchema>;
